import { isDefined } from "@clipboard-health/util-ts";
import { differenceInMinutes } from "date-fns";

import { type Duration, minutesToDuration } from "../../../../DateTime/DurationInput";

const DEFAULT_BREAK_DURATION_MINUTES = 30;

export function calculateBreakDuration(startTime?: Date, endTime?: Date): Duration {
  if (!isDefined(startTime) || !isDefined(endTime)) {
    return minutesToDuration(DEFAULT_BREAK_DURATION_MINUTES);
  }

  const totalMinutes = differenceInMinutes(endTime, startTime);
  return minutesToDuration(totalMinutes);
}
